import { useSelector } from 'react-redux';

import { isErrorReportingEnabled } from 'src/shared/app/base/selector/appEnvSelectors';

export default function useIsErrorReportingEnabled() {
  return useSelector(isErrorReportingEnabled);
}
